import { Component, Vue, Prop } from 'vue-property-decorator'

import { library } from '@fortawesome/fontawesome-svg-core'
import {
	faChevronDown,
	faChevronUp,
	faPlus,
} from '@fortawesome/free-solid-svg-icons'

import Loader from '@/components/Loader/index.vue'
import TypeableDatePortal from '@/components/edit/TypeableDatePortal/index.vue'
import Actions from '@/components/Actions/index.vue'
import CreateCollaboratorModal from './CreateCollaboratorModal/index.vue'
import EntryModal from './EntryModal/index.vue'
import DeleteEntryModal from './DeleteEntryModal/index.vue'

import { genId } from '@/helpers/gen-id'
import date from '@/helpers/date'
import api from '@/helpers/fetch'

library.add(faChevronDown, faChevronUp, faPlus)

@Component({
	components: {
		Loader,
		TypeableDatePortal,
		CreateCollaboratorModal,
		Actions,
		EntryModal,
		DeleteEntryModal,
	},
})
export default class Vacations extends Vue {
	@Prop({ default: 'Outros', type: String }) workRegime!: string

	loading = false
	groupedUsers = [] as any[]

	selectedDelete = {}
	selectedEdit = {}

	tableFields = [
		{
			key: 'index',
			label: '#',
			thStyle: 'width: 1%',
		},
		{
			key: 'periodo_aquisitivo',
			label: 'Período aquisitivo',
		},
		{
			key: 'periodo_gozo',
			label: 'Período de gozo',
		},
		{
			key: 'periodo_abono',
			label: 'Período de abono',
		},
		{
			key: 'date_limit',
			label: 'Limite concessão',
		},
		{
			key: 'situation',
			label: 'Situação',
		},
		{
			key: 'type',
			label: 'Tipo',
		},
		{
			key: 'used_days',
			label: 'Dias gozados',
		},
		{
			key: 'balance',
			label: 'Saldo',
		},
		{
			key: 'actions',
			label: 'Ações',
			thStyle: 'width: 1%',
		},
	]

	async mounted() {
		await this.loadUsers()
	}

	// recebe data 'YYYY-MM-DD' retorna 'DD/MM/YYYY'
	formatDate(datestring) {
		if (!datestring) return ''
		const [year, month, day] = datestring.split('-')
		return `${day}/${month}/${year}`
	}

	daysUntil(datestring) {
		return date.daysUntil(datestring)
	}

	showDeleteModal(item) {
		this.selectedDelete = item
		this.$bvModal.show('delete-entry-modal')
	}

	showEditModal(item) {
		this.selectedEdit = item
		this.$bvModal.show('entry-modal')
	}

	showCreateModal(item) {
		const addOneYear = function (datestring) {
			if (!datestring) return null
			const [year, month, day] = datestring.split('-')
			return `${parseInt(year) + 1}-${month}-${day}`
		}

		this.selectedEdit = {
			id: null,
			acquisition_period_start: addOneYear(item.acquisition_period_start),
			acquisition_period_end: addOneYear(item.acquisition_period_end),
			usage_period_start: null,
			usage_period_end: null,
			allowance_period_start: null,
			allowance_period_end: null,
			date_limit: addOneYear(item.date_limit),
			type: '',
			situation: 'A vencer',
			user_id: item.user_id,
			work_regime: item.work_regime,
			used_days: 0,
			balance: 0,
		}
		this.$bvModal.show('entry-modal')
	}

	async loadUsers() {
		this.loading = true
		const res = await api.get('/api/vacations?work_regime=' + this.workRegime)

		const agrupadoPorUser = res.data.reduce((acumulador, item) => {
			const userId = item.user_id
			item.htmlId = genId()

			if (!acumulador[userId]) {
				acumulador[userId] = {
					user_id: userId,
					name: item.name,
					email: item.email,
					classVariant: 'success',
					collapsed: false,
					htmlId: genId(),
					data: [] as any[],
				}
			}

			if (
				item.situation === 'Parcial' &&
				new Date(item.date_limit).getTime() >= Date.now() &&
				date.daysUntil(item.date_limit) > 120
			) {
				acumulador[userId].classVariant = 'warning'
			} else if (
				item.situation === 'Vencido' ||
				(item.situation === 'Parcial' &&
					new Date(item.date_limit).getTime() >= Date.now() &&
					date.daysUntil(item.date_limit) <= 120)
			) {
				acumulador[userId].classVariant = 'danger'
			}

			acumulador[userId].data.push(item)

			return acumulador
		}, {})

		/**
		 * Função auxiliar para comparar datas ISO ou nulls
		 * Coloca valores null primeiro e valores preenchidos no final.
		 */
		function compararDatas(dataA, dataB) {
			if (!dataA && !dataB) return 0 // Ambas nulas (iguais)
			if (dataA && !dataB) return 1 // A vem primeiro
			if (!dataA && dataB) return -1 // B vem primeiro

			// Como estão no formato ISO, a ordem alfabética é idêntica à ordem cronológica
			return dataA < dataB ? 1 : dataA > dataB ? -1 : 0
		}

		// Transformar de objeto para array e Ordenar pelo 'name'
		this.groupedUsers = Object.values(agrupadoPorUser).sort(
			(a: any, b: any) => {
				// localeCompare é a melhor forma de ordenar strings no JS (lida bem com acentos)
				return a.name.localeCompare(b.name)
			},
		)
		// Ordenar o array 'data' de cada colaborador
		this.groupedUsers.forEach((usuario) => {
			usuario.data.sort((a, b) => {
				return compararDatas(a.usage_period_start, b.usage_period_start)
			})

			usuario.data.sort((a, b) => {
				return compararDatas(a.date_limit, b.date_limit)
			})
		})

		this.loading = false
	}

	get existingUsers() {
		return this.groupedUsers.map((item) => item.user_id)
	}

	getExpiringBalance(list) {
		return list.find((item) => {
			return (
				item.situation === 'Parcial' &&
				new Date(item.date_limit).getTime() >= Date.now()
			)
		})
	}

	getExpiredBalance(list) {
		return list.find((item) => item.situation === 'Vencido')
	}
}
